<div class="box card-box m-x-sm">
  <div class="box-body">
    <ng-container
      gp-roles
      [userRoles]="['SDC3_ADMIN']">
      <button class="btn btn-sm btn-outline-primary m-a-sm"
              test-id="force-sync-payroll-sdc3-btn"
              (click)="forceSyncPayrollToSDC3()"
              placement="bottom" [adaptivePosition]="false" container="body" triggers="mouseenter:mouseleave"
              tooltip="Send payroll from SDWP (delta + failed since last sync) to SDC3 and LPE">
        <em class="fa fa-light fa-sync"></em>&nbsp;Resync payroll (SDC3)
      </button>
    </ng-container>
  </div>
</div>
<div class="box card-box m-x-sm">
  <div class="box-header logs-tabs-header">
    <div class="nav nav-tabs">
      <div class="nav-item text-center" (click)="activeLogTab = 'sdc'">
        <a class="nav-link block text-ellipsis" [ngClass]="{'active': activeLogTab === 'sdc'}">
          <span>Sdc logs</span>
        </a>
      </div>
      <div class="nav-item text-center" gp-roles [userRoles]="['SDC3_ADMIN']"
           (click)="activeLogTab = 'payroll'">
        <a class="nav-link block text-ellipsis" [ngClass]="{'active': activeLogTab === 'payroll'}">
          <span>Payroll logs</span>
        </a>
      </div>
    </div>
    <ul class="nav logs-tabs-tools">
      <li class="nav-item inline m-r-1" *ngIf="activeLogTab === 'payroll'">
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" id="onlyLatestCheckbox"
                 (change)="toggleDisplayLatestPayrollLogsOnly($event)"
                 [checked]="displayLatestPayrollLogsOnly">
          <label class="form-check-label" for="onlyLatestCheckbox">Display latest only</label>
        </div>
      </li>
      <li class="nav-item inline">
        <a class="nav-link" (click)="reloadActiveLogs()">
          <i class="fa-solid fa-rotate"></i>
        </a>
      </li>
    </ul>
  </div>
  <div class="box-body">
    <gp-sdc-logs-list *ngIf="activeLogTab === 'sdc' && contractId"
                      [contractId]="contractId"
                      [includedTypes]="[SdcEventTypes.SDC3_PAYROLL_INPUT]"></gp-sdc-logs-list>
    <gp-person-payroll-logs-list *ngIf="activeLogTab === 'payroll'"
                                 [contractId]="contractId"
                                 [latestOnly]="displayLatestPayrollLogsOnly"
                                 [sdcLogType]="SdcEventTypes.SDC3_PAYROLL_INPUT"></gp-person-payroll-logs-list>
  </div>
</div>
